import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import ProdCard from "../../components/box/ProdCard";
import ProductService from "../../services/productService";

const WishList: React.FC = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const { t } = useTranslation();
  const { data: products } = useQuery("wishList", async () => {
    const currentWishList = localStorage.getItem("wishList");
    const wishListArray = currentWishList
      ? currentWishList.split(",").map(Number)
      : [];
    return ProductService.getWishList(wishListArray);
  });

  // JSON data
  const data = [
    {
      title: t("Pass"),
      data:
        products?.filter((product: any) => product.productType === "PASS") ||
        [],
    },
    {
      title: t("Ticket"),
      data:
        products?.filter((product: any) => product.productType === "TICKET") ||
        [],
    },
    {
      title: t("Tour"),
      data:
        products?.filter((product: any) => product.productType === "TOUR") ||
        [],
    },
    {
      title: t("Musical"),
      data:
        products?.filter((product: any) => product.productType === "MUSICAL") ||
        [],
    },
    {
      title: t("E-Sim"),
      data:
        products?.filter((product: any) => product.productType === "SIM") || [],
    },
  ];

  // Pagination configuration
  const itemsPerPage = 12;
  const paginatedData = (tickets: (typeof data)[0]["data"]) =>
    tickets.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);
  return (
    <>
      {data
        .filter((category) => category.data.length > 0)
        .map((category) => (
          <section className="flex-1 mb-[4.375rem]" key={category.title}>
            <div className="flex justify-between items-center mb-10">
              <p className="text-[#232323] text-[1.375rem] font-semibold">
                {category.title}
              </p>
            </div>

            <div className="grid grid-cols-2 gap-x-6 gap-y-[1.875rem]">
              {paginatedData(category.data).map((product) => (
                <ProdCard key={product.id} {...product} />
              ))}
            </div>
          </section>
        ))}
    </>
  );
};

export default WishList;
